/** Default cart item TTL for non-timed items (products, packages, credits). */
export const CART_DEFAULT_TTL_SECONDS = 86400; // 24 hours
